import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchSlrmBillReportThunk = createAsyncThunk(
  "slrmBillReport/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const params = {
        from_date: filters?.from_date || "",
        to_date: filters?.to_date || "",
        ward_id: filters?.ward_id || "",
        agent_id: filters?.agent_id || "",
      };

      const res = await api.get("/api/reports/slrm-bill-report", { params });

      if (!res.data?.success) {
        return rejectWithValue(res.data?.message || "Failed to load report");
      }
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const slrmBillReportSlice = createSlice({
  name: "slrmBillReport",
  initialState: {
    rows: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearSlrmBillReport: (state) => {
      state.rows = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSlrmBillReportThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSlrmBillReportThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload || [];
      })
      .addCase(fetchSlrmBillReportThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load report";
      });
  },
});

export const { clearSlrmBillReport } = slrmBillReportSlice.actions;
export default slrmBillReportSlice.reducer;